/**
 * Created by jonas on 2020-09-17.
 */


import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {WinWayDisplay} from "../components/WinWayDisplay";
import {CountUpMultiplier} from "../components/CountUpMultiplier";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TheCage} from "../TheCage";

import {gsap} from "gsap";
import {TheCageTextStyles} from "../config/TheCageTextStyles";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {LineWinDisplay} from "../components/LineWinDisplay";
import {Coordinate2d} from "../../core/reel/simplereel/SimpleReelModel";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheCageSound} from "../sound/TheCageSound";
import {BetWayWin} from "../server/TheCageData";
import {StateMatrixCoordinate} from "../utils/StateMatrix";
import {ParticleBurst} from "./parts/ParticleBurst";
import {TheCageGameMode} from "../server/TheCageGameMode";


export class TheCageWinView extends PIXI.Container implements StageLayer {
    private _countUp:BasicBitmapCountUp;
    private _maxWinCountUp:BasicBitmapCountUp;
    private _winWaysCountUp:WinWayDisplay;
    private _winWaysToggle:WinWayDisplay;
    private _countContainer:PIXI.Container;
    private _maxWinCountContainer:PIXI.Container;
    private _winAmountToggle:PIXI.BitmapText;
    private _multiplierToggle:PIXI.Text;
    private _multiplierText:CountUpMultiplier;

    private countUpLayer:PIXI.Container;
    private winWayLayer:PIXI.Container;
    private wildMining:PIXI.spine.Spine;
    private _bigWinAnimations:PIXI.spine.Spine[];
    private _bigWinContainer:PIXI.Container;
    private _blackOut:PIXI.Sprite;
    private _maxWinAnimation:PIXI.spine.Spine;
    public particleBurst:ParticleBurst;

    constructor() {
        super();
        this.name = "TheCageWinView";
        this.init();
    }

    private init() {
        this._countUp = new BasicBitmapCountUp(TheCageTextStyles.WIN_COUNT_UP, 700, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(0, 0);

        this._maxWinCountUp = new BasicBitmapCountUp(TheCageTextStyles.WIN_CAP_COUNT_UP, 700, new PIXI.Point(0.5, 0.5));
        this._maxWinCountUp.position.set(0, 0);

        this._winWaysCountUp = new WinWayDisplay(true);
        this._winWaysCountUp.position.set(0, 110);

        this._blackOut = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._blackOut.name = "blackOut";
        this._blackOut.tint = 0;
        this._blackOut.position.set(360,360);
        this._blackOut.anchor.set(0.5,0.5);
        this._blackOut.alpha = 0;



        const multiplierTextStyle = {
            fontName:TheCageGameAssets.BITMAP_FONT_MULTIPLIER_COUNTER,
            fontSize:156,
            tint:0xffffff,
        };
        this._multiplierText = new CountUpMultiplier(multiplierTextStyle);
        this._multiplierText.position.set(0, -100);

        this._countContainer = new PIXI.Container();
        this._countContainer.name = "_countContainer";
        this._countContainer.alpha = 0;
        this._countContainer.position.set(360, 280);
        this._countContainer.addChild(this._countUp, this._winWaysCountUp, this._multiplierText);

        this._maxWinCountContainer = new PIXI.Container();
        this._maxWinCountContainer.name = "_maxWinCountContainer";
        this._maxWinCountContainer.alpha = 0;
        this._maxWinCountContainer.position.set(360, 280);
        this._maxWinCountContainer.addChild(this._maxWinCountUp);

        this._winAmountToggle = new PIXI.BitmapText("", {
            fontName:TheCageGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize:156 * 0.8,
            tint:0xffffff
        });
        this._winAmountToggle.anchor = new PIXI.Point(0.5, 0.5);
        this._winWaysToggle = new WinWayDisplay(true);
        this._winWaysToggle.position.set(0, 0);


        const multiplierStyle:PIXI.TextStyle = new PIXI.TextStyle({
            fill:0xffffff,
            fontFamily:OpenSans.FAMILY,
            wordWrap:false,
            fontWeight:FontWeight.BOLD,
            fontSize:50,
            dropShadow:true,
            dropShadowAngle:1.5,
            dropShadowBlur:5,
            dropShadowDistance:10,
        });
        this._multiplierToggle = new PIXI.Text("", multiplierStyle);
        this._multiplierToggle.anchor = new PIXI.Point(0.5, 0.5);


        this.particleBurst = new ParticleBurst();

        this._bigWinContainer = this.createBigWinGraphics();

        this.wildMining = new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.WILD_MINING_SPINE));
        this.wildMining.position.set(360,360);
        this.wildMining.visible = false;

        this.countUpLayer = new PIXI.Container();
        this.countUpLayer.name = "countUpLayer";
        this.winWayLayer = new PIXI.Container();
        this.winWayLayer.name = "winWayLayer";

        this.addChild(this._blackOut);
        this.addChild(this._bigWinContainer);
        this.addChild(this.winWayLayer);
        this.addChild(this.particleBurst);
        this.addChild(this.countUpLayer);
        this.addChild(this.wildMining);

        this.onResize();
    }

    public onResize() {
        this._blackOut.width = NolimitApplication.screenBounds.width;
        this._blackOut.height = NolimitApplication.screenBounds.height;
    }

    private createBigWinGraphics():PIXI.Container{
        const container = new PIXI.Container();
        container.name = "bigWinContainer";
        container.position.set(360, 360);
        container.alpha = 0;
        container.visible = false;

        this._bigWinAnimations = [
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_1)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_2)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_3)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_4)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.BIG_WIN_SPINE_LEVEL_5)),
        ];

        this._maxWinAnimation = new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.MAX_WIN));
        this._maxWinAnimation.name = "maxWin";
        this._maxWinAnimation.visible = false;

        const bigWinSpineContainer = new PIXI.Container();
        bigWinSpineContainer.name = "spineContainer";
        bigWinSpineContainer.addChild(this._maxWinAnimation);

        for (let i:number = this._bigWinAnimations.length-1; i >= 0; i--){
            const bigWin = this._bigWinAnimations[i];
            bigWin.name = "bigWinLvl_" + (i+1);
            bigWin.visible = false;
            bigWinSpineContainer.addChild(bigWin);
        }
        container.addChild(bigWinSpineContainer);

        return container;
    }

    public getCountUpScaleAnimation(fromCount:number, toCount:number, duration:number, fromScale:number, toScale:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {
            this._countUp.scale.set(fromScale, fromScale);
            this._countUp.preCalculateScale(fromCount, toCount);
        });

        tl.add(gsap.to(this._countUp.scale, {duration:duration, x:toScale, y:toScale, ease:"none"}));

        return tl;
    }

    public getPositionAnimation(duration:number, toPosition:PIXI.Point, ease:string):gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(gsap.to(this._countContainer.position, {duration:duration, x:toPosition.x, y:toPosition.y, ease:ease}));

        return tl;
    }

    public getWinCountUp(from:number, to:number, duration:number, ways:number = 0, pos:PIXI.Point = new PIXI.Point(360, 360), skipSound:boolean = false, shouldPump:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const winWaysShowDuration = duration > 0.3 ? 0.3 : 0.01;
        const winWaysShow = this._winWaysCountUp.getShowAnimation(ways, winWaysShowDuration);
        const pumpAnim = gsap.timeline();
        if (shouldPump) {
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.05, x:1.2, y:1.2, ease:"none"}));
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.3, x:1, y:1}));
        }

        tl.add(() => {
            this._countContainer.position.set(pos.x, pos.y);
            this.countUpLayer.addChild(this._countContainer);
        });

        if (!skipSound) {
            tl.add(() => {
                TheCage.soundPlayer.startCountUp();
            })
        }

        if (duration > 0) {
            if (winWaysShow) {
                tl.add([
                    this._countUp.getCountAnimation(from, to, duration),
                    winWaysShow,
                    pumpAnim
                ]);
            } else {
                tl.add([
                    this._countUp.getCountAnimation(from, to, duration),
                    pumpAnim
                ]);
            }
        } else {
            this._countUp.preCalculateScale(from, to);
        }

        tl.add(gsap.to(this._countContainer, {duration:0.02, alpha:1, ease:"none"}),0);


        tl.add(() => {
            this._countUp.stopAt(to, false);
        });


        return tl;
    }

    public getMaxWinCountUp(from:number, to:number, duration:number, ways:number = 0, pos:PIXI.Point = new PIXI.Point(360, 360), skipSound:boolean = false, shouldPump:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._maxWinCountContainer.position.set(pos.x, pos.y);
            this.countUpLayer.addChild(this._maxWinCountContainer);
        });

        if (!skipSound) {
            tl.add(() => {
                TheCage.soundPlayer.startCountUp();
            })
        }

        tl.add( this._maxWinCountUp.getCountAnimation(from, to, duration));

        tl.add(gsap.to(this._maxWinCountContainer, {duration:0.02, alpha:1, ease:"none"}),0);


        tl.add(() => {
            this._countUp.stopAt(to, false);
        });


        return tl;
    }

    public getMaxWinCountUpEnd(accumulatedRoundWin:number, stayDuration:number, ways:number = 0, endSound:string = "") {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            TheCage.soundPlayer.endCountUp(endSound);
            this.countUpLayer.addChild(this._maxWinCountContainer);
        });
        tl.add(() => {this._maxWinCountUp.stopAt(accumulatedRoundWin, false);});

        tl.add(gsap.to(this, {duration:stayDuration}));

        return tl;
    }

    public getMaxWinCountUpFade(accumulatedRoundWin:number, fadeDuration:number = 0.3) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this._maxWinCountContainer, {duration:fadeDuration, alpha:0, ease:"none"}),
            gsap.to(this._maxWinCountContainer.position, {duration:fadeDuration, y:this._maxWinCountContainer.position.y-100, ease:"none"})
        ]);
        tl.add(() => {
            this.countUpLayer.removeChild(this._maxWinCountContainer);
            this._maxWinCountContainer.position.set(0, 0);
        });

        return tl;
    }

    public getWinCountUpEnd(accumulatedRoundWin:number, stayDuration:number, ways:number = 0, endSound:string = "") {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            if (!TheCage.isWinBelowStake()) {
                TheCage.soundPlayer.endCountUp(endSound);
            }
            this.countUpLayer.addChild(this._countContainer);
        });
        tl.add(() => {
            this._countUp.stopAt(accumulatedRoundWin, false);
            this._winWaysCountUp.position.set(0, this._countUp.height * 0.5 + 10);
            this._winWaysCountUp.scale.set(this._countUp.scale.x + 0.6, this._countUp.scale.y + 0.6);
            this._winWaysCountUp.getShowAnimation(ways, 0.01);
        });

        tl.add(gsap.to(this, {duration:stayDuration}));

        return tl;
    }

    public getWinCountUpFade(accumulatedRoundWin:number, fadeDuration:number = 0.3) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this._countContainer, {duration:fadeDuration, alpha:0, ease:"none"}),
            gsap.to(this._countContainer.position, {duration:fadeDuration, y:this._countContainer.position.y-100, ease:"none"})
        ]);
        tl.add(() => {
            this._multiplierText.reset();
            this.countUpLayer.removeChild(this._countContainer);
            this._countContainer.position.set(0, 0);
        });

        return tl;
    }

    public getBigWinAnimation(startAnim:string, level:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        let currentLevel:PIXI.spine.Spine | undefined;
        if (level > 1){
            currentLevel = this._bigWinAnimations[level-2];
        }
        const nextLevel = this._bigWinAnimations[level-1];

        tl.add(()=>{
            this._bigWinContainer.visible = true;
            nextLevel.visible = true;
            nextLevel.alpha = 1;
            nextLevel.updateTransform();
            nextLevel.state.setAnimation(0,"A", false);
        })
        tl.add(gsap.to(this._bigWinContainer, {duration:0.2, alpha:1, ease:"none"}));
        tl.add(gsap.to(this._blackOut, {duration:0.2, alpha:0.7, ease:"none"}), "<");


        if (currentLevel){
            tl.add(gsap.to(currentLevel!, {duration:0.4, alpha:0, ease:"none"}), "<");
            tl.add(()=>{
                currentLevel!.visible = false;
            });
        }

        return tl;
    }

    public getMaxWinAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(()=>{
            this._bigWinContainer.visible = true;
            this._maxWinAnimation.visible = true;
            this._maxWinAnimation.alpha = 1;
            this._maxWinAnimation.updateTransform();
        })
        tl.add(SpineGSAPWrapper.createTimeline(this._maxWinAnimation, 0, "wc_intro", -1));
        tl.add(SpineGSAPWrapper.createTimeline(this._maxWinAnimation, 0, "wc_defeat_loop", -1));

        tl.add(gsap.to(this._bigWinContainer, {duration:0.2, alpha:1, ease:"none"}),0);
        tl.add(gsap.to(this._blackOut, {duration:0.2, alpha:0.7, ease:"none"}), 0);

        return tl;
    }

    public getBigWinEnd(stayDuration:number = 1):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this, {duration:stayDuration - 0.3}));
        tl.add(gsap.to(this._bigWinContainer, {duration:0.3, alpha:0, ease:"none"}));
        tl.add(gsap.to(this._blackOut, {duration:0.3, alpha:0.0, ease:"none"}), "<");

        tl.add(()=>{
            this._bigWinContainer.alpha = 0;
            this._bigWinContainer.visible = false;

            for (let i:number = this._bigWinAnimations.length-1; i >= 0; i--){
                const bigWin = this._bigWinAnimations[i];
                bigWin.state.setEmptyAnimation(0,0);
                bigWin.updateTransform();
                bigWin.alpha = 0;
                bigWin.visible = false;
            }
        })


        return tl;

    }

    public getMultiplier(multiplier:number, finalValue:boolean = false, duration:number = 0.3, withExplosion:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(this._multiplierText.getAnimation(multiplier, duration));

        /*
                if (withExplosion) {
                    tl.add(() => this.getMultiplierExplosion(), "<");
                }
        */

        /*        tl.add(() => {
                    if (finalValue || withExplosion) {
                        Octagon.soundPlayer.playSound(OctagonSound.COUNT_MULTIPLIER_ENDS);
                    } else {
                        Octagon.soundPlayer.playSound(OctagonSound.COUNT_MULTIPLIER);
                    }
                }, 0);*/

        return tl;
    }

    public getWildMiningText():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(()=>{
           this.wildMining.visible = true;
        });
        tl.add(()=>{TheCage.soundPlayer.playSound(TheCageSound.WILD_MINING.next())});
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.wildMining,0,"base"));

        return tl;
    }

    public playLineWinDisplayGroup(datas:{betWin:BetWayWin, reelPos:StateMatrixCoordinate}[], durScale:number = 1):gsap.core.Timeline {
        const tl = gsap.timeline();

        let centerPos: Coordinate2d;
        if (TheCage.model.data.mode == TheCageGameMode.FREESPIN || TheCage.model.data.mode == TheCageGameMode.FREESPIN_AVALANCHE) {
            centerPos = TheCage.freeSpinReelView.startPositions[datas[0].reelPos.column][datas[0].reelPos.row];
        } else {
            centerPos = TheCage.reelView.startPositions[datas[0].reelPos.column][datas[0].reelPos.row];
        }

        const container = new PIXI.Container();
        if (TheCage.model.gameData.mode == TheCageGameMode.FREESPIN || TheCage.model.gameData.mode == TheCageGameMode.FREESPIN_AVALANCHE) {
            // fix alignment issues due to freespin reels having 0.85 scale
            const xPos = ((centerPos.x - 360) * 0.85 + 360);
            const yPos = ((centerPos.y - 360) * 0.85 + 360);
            container.position.set(xPos, yPos - (30 * (datas.length - 1)));
        } else {
            container.position.set(centerPos.x, centerPos.y - (30 * (datas.length - 1)));
        }


        tl.add(()=>{
            this.addChild(container);
        })
        for (let i:number = 0; i < datas.length; i++){
            const data = datas[i];
            const display = new LineWinDisplay(data.betWin);
            display.position.set(0, 60 * i);
            display.alpha = 0;
            container.addChild(display);
            tl.add(display.getAnimation(durScale),0);

        }
        tl.add(()=>{
            this.removeChild(container);
        })


        return tl;
    }

    public playLineWinDisplays(amountData:{betWin:BetWayWin, reelPos:StateMatrixCoordinate}[], durScale = 1){

        const keys:string[] = [];
        let sorted:{[index:string] : {betWin:BetWayWin, reelPos:StateMatrixCoordinate}[]} = {};

        for (let item of amountData){
            const key = `${item.reelPos.column}_${item.reelPos.row}`;
            if (sorted[key] == undefined){
                sorted[key] = [];
                keys.push(key);

            }
            sorted[key].push(item);
        }

        const tl = gsap.timeline();

        for (let key of keys){
            tl.add(this.playLineWinDisplayGroup(sorted[key], durScale), 0);
        }

        return tl;
    }

}